import React from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useTranslation } from 'react-i18next'

import { useDispatch } from '@hozana/redux/hooks'
import { getFullUrl } from '@hozana/router/functions'
import { useScreen } from '@hozana/screen/useScreen'

import { RoundButton, TRoundButtonProps } from 'elements/button/RoundButton'

import { ICON } from 'config/icons'
import { addFlash } from 'general/actions'
import { PAGE } from 'routes/constants'

export type TShareFaqProps = {
  question: {
    id: number
    order: number
    category: string
    title: string
    answer: string
  }
} & Pick<TRoundButtonProps, 'color'>

export const ShareFaq: TFC<TShareFaqProps> = ({ question, color = 'black10' }) => {
  const {
    i18n: { language },
  } = useTranslation()
  const screen = useScreen()
  const dispatch = useDispatch()

  return (
    <CopyToClipboard
      text={getFullUrl({ pathname: PAGE.FAQ_HIGHLIGHT, query: { id: question.id } }, language)}
      onCopy={() => {
        dispatch(
          addFlash({
            message: 'home:share.copy-link-success',
            subMessage: screen.xs ? undefined : 'home:share.copy-paste-link-explanations',
          }),
        )
      }}
    >
      <RoundButton color={color} hoverColor="black50" icon={ICON.LINK} label="trans:home:share.copy-link" />
    </CopyToClipboard>
  )
}
